// extracted by mini-css-extract-plugin
export var content = "LoginForm-module__content___Pp4Ht";
export var forgotPassword = "LoginForm-module__forgotPassword___Dwcbv";
export var gap = "LoginForm-module__gap___gs3yh";
export var heading = "LoginForm-module__heading___FXS3v";
export var sectionDivider = "LoginForm-module__sectionDivider___dNygA";
export var wrapper = "LoginForm-module__wrapper___hnQ31";